import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SettingsLocationState {
  showUnknownLocations: boolean;
  selectedLocationId: string | null;
}

const initialState: SettingsLocationState = {
  showUnknownLocations: false,
  selectedLocationId: null,
};

const settingsLocationsSlice = createSlice({
  name: 'settingsLocations',
  initialState,
  reducers: {
    setShowUnknownLocations(state, action: PayloadAction<boolean>) {
      state.showUnknownLocations = !!action.payload;
    },
    setSelectedLocationId(state, action: PayloadAction<string | null>) {
      state.selectedLocationId = action.payload ?? null;
    },
    clearSelectedLocationId(state) {
      state.selectedLocationId = null;
    },
  },
});

export const {
  setShowUnknownLocations,
  setSelectedLocationId,
  clearSelectedLocationId,
} = settingsLocationsSlice.actions;

export const settingsLocationsReducer = settingsLocationsSlice.reducer;
